import { File } from '../file';
import { Navigation } from '../navigation';
import { HeaderBar } from './bar';

/**
 * Model definition for Navigation
 */
export interface HeaderNavigation {
  __component: 'header.navigation';
  id: string;
  logo?: File;
  navigation?: Navigation;

  // Augmented by app/src/api/header/controllers/header.js Z15
  headerBar?: HeaderBar;
}

export function isHeaderNavigation(obj: { __component?: string }): obj is HeaderNavigation {
  return obj?.__component === 'header.navigation';
}
